import React, { useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import Modal from "react-modal";
import EditEventFormCss from "./EditEventForm.module.css";
import TrashcanIcon from "../../icons/Trash can.svg";
import SpinnerIcon from "../../icons/spinner.svg"; // Assume you have a spinner icon
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage, faTimes } from "@fortawesome/free-solid-svg-icons";
// Ticket types
const ALL_TICKET_TYPES = [
  { label: "Guest List", value: "guest list" },
  { label: "Girls Only: Guest List", value: "GIRLS ONLY: guest list" },
  { label: "Guest List 2nd", value: "guest list 2nd" },
  { label: "Guest List 3rd", value: "guest list 3rd" },
  { label: "Guest List 4th", value: "guest list 4th" },
  { label: "Early Birds Paid Entrance", value: "Early Birds Paid Entrance" },
  { label: "Paid Entrance 1st Offer", value: "Paid Entrance 1st offer" },
  { label: "Paid Entrance 2nd Offer", value: "Paid Entrance 2nd offer" },
  { label: "Paid Entrance 3rd Offer", value: "Paid Entrance 3rd offer" },
  { label: "Paid Entrance 4th Offer", value: "Paid Entrance 4th offer" },
  { label: "Paid Entrance 5th Offer", value: "Paid Entrance 5th offer" },
  { label: "Paid Entrance 6th Offer", value: "Paid Entrance 6th offer" },

  {
    label: "Discount Entrance: Pay Online",
    value: "Discount entrance: pay online"
  },
  {
    label: "Discount Entrance: Pay At The Door",
    value: "Discount entrance: pay at the door"
  },
  {
    label: "Boys: 1st Paid Release Offer",
    value: "BOYS: 1ST Paid RELEASE OFFER"
  },
  {
    label: "Girls: 1st Paid Release Offer",
    value: "GIRLS: 1ST Paid RELEASE OFFER"
  },
  {
    label: "Boys: 2nd Paid Release Offer",
    value: "BOYS: 2ND Paid RELEASE OFFER"
  },
  {
    label: "Girls: 2nd Paid Release Offer",
    value: "GIRLS: 2ND Paid RELEASE OFFER"
  },
  {
    label: "Boys: 3rd Paid Release Offer",
    value: "BOYS: 3RD Paid RELEASE OFFER"
  },
  {
    label: "Girls: 3rd Paid Release Offer",
    value: "GIRLS: 3RD Paid RELEASE OFFER"
  }
];

// Predefined ticket images
const TICKET_IMAGES = {
  "Pago En Puerta": ["https://everywherestorage.blob.core.windows.net/scannerimages/PagoEnPuerta.jpg"],
  "Lista": ["https://everywherestorage.blob.core.windows.net/scannerimages/EntradaEnLista.jpg"],
  "Barra Libre": ["https://everywherestorage.blob.core.windows.net/scannerimages/BarraLibre.jpg"],
  "1-copa": [
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-100.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-95.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-90.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-85.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-80.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-75.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-70.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-65.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-60.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-55.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-50.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-45.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-40.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-35.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-30.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-29.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-28.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-27.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-26.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-25.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-24.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-23.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-22.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-21.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-20.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-19.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-18.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-17.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-16.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-15.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-14.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-13.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-12.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-11.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-10.jpg",
  ],
  "2-copas": [
    "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-100.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-95.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-90.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-85.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-80.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-75.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-70.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-65.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-60.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-55.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-50.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-45.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-40.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-35.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-30.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-25.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-20.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-15.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-10.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-5.jpg",
  ],
  "3-copas": [
    "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-100.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-90.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-85.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-80.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-75.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-70.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-65.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-60.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-55.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-50.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-45.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-40.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-35.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-30.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-25.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-20.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-15.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-10.jpg",
  ],
  "Acceso Sin Consumo": [
    "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-90.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-85.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-80.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-75.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-70.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-65.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-60.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-55.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-50.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-45.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-40.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-35.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-30.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-25.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-20.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-15.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-10.jpg",
    "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-5.jpg",
  ]
};

const EditEventForm = ({
  selectedEventId,
  events,
  ticketsdata,
  adminId,
  setEvents
}) => {
  //console.log("events: ", events);
  const [eventName, setEventName] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [Age, setAge] = useState("");
  const [DressCode, setDressCode] = useState("");
  const [musicTypes, setMusicTypes] = useState([]);
  const [cities, setCities] = useState([]);
  const [djOptions, setDjOptions] = useState([]);
  const [numberOfParticipants, setNumberOfParticipants] = useState(0);
  const [selectedMusicTypes, setSelectedMusicTypes] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);
  const [selectedDJs, setSelectedDJs] = useState([]);
  const [tickets, setTickets] = useState(ticketsdata || []);
  const [selectedTicketType, setSelectedTicketType] = useState(null);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [availableTicketTypes, setAvailableTicketTypes] =
    useState(ALL_TICKET_TYPES);
  const [eventImage, setEventImage] = useState(null); // New state for the event image
  const [previewImageUrl, setPreviewImageUrl] = useState(null); // Preview URL for the uploaded image

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentTicketIndex, setCurrentTicketIndex] = useState(null);

  const [isSubmitting, setIsSubmitting] = useState(false); // New state for loading

  const adminKey = "Bearer " + process.env.REACT_APP_ADMIN_KEY;
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    if (selectedEventId) {
      const selectedEvent = events.find(
        (event) => event._id === selectedEventId
      );
      if (selectedEvent) {
        setEventName(selectedEvent.eventName || "");
        const localDate = new Date(selectedEvent.dateAndHour)
          .toLocaleString("sv-SE", {
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            hour12: false
          })
          .slice(0, 16);
        setEventDate(localDate);
        setAge(selectedEvent.Age || "");
        setDressCode(selectedEvent.DressCode || "");
        setSelectedMusicTypes(
          selectedEvent.music_type.map((type) => ({ value: type, label: type }))
        );
        setSelectedCities(
          selectedEvent.city.map((city) => ({ value: city, label: city }))
        );
        setSelectedDJs(
          selectedEvent.DJ_name.map((dj) => ({ value: dj, label: dj }))
        );
        setNumberOfParticipants(selectedEvent.numberOfParticipants || 0);
        setTickets(selectedEvent.tickets || ticketsdata || []);

        if (selectedEvent.image) {
          setPreviewImageUrl(selectedEvent.image);
        }
      } else {
        console.log("Event data not found for ID:", selectedEventId);
      }
    }
  }, [selectedEventId, events, ticketsdata]);

  useEffect(() => {
    const selectedTicketTypes = tickets.map((ticket) => ticket.ticketType);
    setAvailableTicketTypes(
      ALL_TICKET_TYPES.filter(
        (type) => !selectedTicketTypes.includes(type.value)
      )
    );
  }, [tickets]);

  //FETCH BASIC DATA
  /// WE TAKE CARE OF BASIC INFO
  const fetchDjNames = async () => {
    try {
      let token = localStorage.getItem("token");
      const response = await axios.get(`${BACKEND_URL}/admin/getDjNames/`,
        {
          headers: {
            authorization: `Bearer ${token}`
          }
        }
      );
      if (response.status === 200) {
        setDjOptions(
          response.data.map((djName) => ({ value: djName, label: djName }))
        );
      }
    } catch (error) {
      console.error("Failed to fetch DJ names:", error);
    }
  };
  const fetchMusicTypes = async () => {
    try {
      let token = localStorage.getItem("token");
      const response = await axios.get(`${BACKEND_URL}/admin/music-types/`,
        {
          headers: {
            authorization: `Bearer ${token}`
          }
        }
      );
      if (response.status === 200) {
        console.log("Music: ", response.data.music_types);
        setMusicTypes(
          response.data.music_types.map((music_type) => ({
            value: music_type,
            label: music_type
          }))
        );
      }
    } catch (error) {
      console.error("Failed to fetch DJ names:", error);
    }
  };
  const fetchCities = async () => {
    try {
      let token = localStorage.getItem("token");
      const response = await axios.get(`${BACKEND_URL}/admin/cities/`,
        {
          headers: {
            authorization: `Bearer ${token}`
          }
        }
      );
      if (response.status === 200) {
        setCities(
          response.data.cities.map((city) => ({
            value: city,
            label: city
          }))
        );
      }
    } catch (error) {
      console.error("Failed to fetch DJ names:", error);
    }
  };
  useEffect(() => {
    // Assuming you have a function to load your backend URL
    fetchDjNames();
    fetchMusicTypes();
    fetchCities();
  }, []);

  const handleTicketChange = (index, name, value) => {
    const updatedTickets = [...tickets];
    updatedTickets[index][name] = value;
    setTickets(updatedTickets);
  };

  const handleTicketSelect = (selectedOption) => {
    if (!tickets.some((ticket) => ticket.ticketType === selectedOption.value)) {
      setTickets([
        ...tickets,
        {
          ticketType: selectedOption.value,
          price: "",
          numberOfTicketsLeft: "",
          description: "",
          ticketImage: "" // New ticket needs an image
        }
      ]);
    }
  };

  const handleDeleteTicket = (index) => {
    const updatedTickets = tickets.filter(
      (_, ticketIndex) => ticketIndex !== index
    );
    setTickets(updatedTickets);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file && (file.type === "image/jpeg" || file.type === "image/png")) {
      setEventImage(file);
      setPreviewImageUrl(URL.createObjectURL(file));
    } else {
      alert("Only .jpg, .jpeg, and .png formats are allowed.");
    }
  };

  const handleSelectTicketImage = (index) => {
    setCurrentTicketIndex(index);
    setIsModalOpen(true);
  };

  const handleImageSelection = (imageUrl) => {
    const updatedTickets = [...tickets];
    updatedTickets[currentTicketIndex].ticketImage = imageUrl;
    setTickets(updatedTickets);
    setIsModalOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); // Set loading state to true
    const eventDateUTC = new Date(eventDate).toISOString();

    const updatedEventDetails = {
      eventName,
      eventDate: eventDateUTC,
      Age,
      DressCode,
      music_type: selectedMusicTypes.map((type) => type.value),
      city: selectedCities.map((city) => city.value),
      DJ_name: selectedDJs.map((dj) => dj.value)
    };

    try {
      const formData = new FormData();
      formData.append("eventDetails", JSON.stringify(updatedEventDetails));
      formData.append("tickets", JSON.stringify(tickets));
      formData.append("userId", adminId);

      if (eventImage) {
        formData.append("eventImage", eventImage);
      }
      console.log(`${BACKEND_URL}/admin/updateEvent/${selectedEventId}`);
      let token = localStorage.getItem("token");
      const response = await axios.post(
        `${BACKEND_URL}/admin/updateEvent/${selectedEventId}`,
        formData,
        {
          headers: {
            authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data"
          }
        }
      );
      console.log("response: ", response);
      if (response.status === 200) {
        //console.log("response.data.updatedEvent: ", response.data.updatedEvent);
        /*setEvents((prevEvents) => {
          return prevEvents.map((event) =>
            event._id === selectedEventId
              ? { ...event, ...response.data.updatedEvent }
              : event
          );
        });*/
        alert("Event updated successfully!");
      } else {
        alert("Failed to update event. Please try again.");
      }
    } catch (error) {
      console.error("Error updating event:", error);
      alert("An error occurred while updating the event.");
    } finally {
      setIsSubmitting(false); // Set loading state to false
    }
  };

  const customSelectStyles = {
    control: (provided) => ({
      ...provided,
      flexDirection: "row-reverse"
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "black"
    }),
    option: (provided) => ({
      ...provided,
      color: "black"
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      transform: "rotate(180deg"
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999
    }),
    menu: (provided) => ({
      ...provided,
      position: "absolute",
      top: "auto",
      bottom: "100%",
      zIndex: 9999
    })
  };
  const customSelectStylesTickets = {
    control: (provided) => ({
      ...provided,
      flexDirection: "row-reverse",
      maxWidth: "400px",
      width: "100%"
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "black"
    }),
    option: (provided) => ({
      ...provided,
      color: "black"
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      transform: "rotate(180deg"
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999
    }),
    menu: (provided) => ({
      ...provided,
      position: "absolute",
      top: "auto",
      bottom: "100%",
      zIndex: 9999,
      maxWidth: "400px"
    })
  };

  return (
    <form onSubmit={handleSubmit} className={EditEventFormCss.editForm}>
      <div className={EditEventFormCss.formGroup}>
        <label>Event Name</label>
        <input
          type="text"
          value={eventName}
          onChange={(e) => setEventName(e.target.value)}
        />
      </div>
      <div className={EditEventFormCss.formGroup}>
        <label>Event Date and Time</label>
        <input
          type="datetime-local"
          value={eventDate}
          onChange={(e) => setEventDate(e.target.value)}
        />
      </div>
      <div className={EditEventFormCss.formGroup}>
        <label>Age</label>
        <input
          type="text"
          value={Age}
          onChange={(e) => setAge(e.target.value)}
        />
      </div>
      <div className={EditEventFormCss.formGroup}>
        <label>Dress Code</label>
        <input
          type="text"
          value={DressCode}
          onChange={(e) => setDressCode(e.target.value)}
        />
      </div>
      <div className={EditEventFormCss.formGroup}>
        <label>Music Type</label>
        <Select
          value={selectedMusicTypes}
          isMulti
          options={musicTypes}
          onChange={setSelectedMusicTypes}
          styles={customSelectStyles}
          menuPlacement="top"
          menuPortalTarget={document.body}
        />
      </div>
      <div className={EditEventFormCss.formGroup}>
        <label>City</label>
        <Select
          value={selectedCities}
          isMulti
          options={cities}
          onChange={setSelectedCities}
          styles={customSelectStyles}
          menuPlacement="top"
          menuPortalTarget={document.body}
        />
      </div>
      <div className={EditEventFormCss.formGroup}>
        <label>DJ Name</label>
        <Select
          value={selectedDJs}
          isMulti
          options={djOptions}
          onChange={setSelectedDJs}
          styles={customSelectStyles}
          menuPlacement="top"
          menuPortalTarget={document.body}
        />
      </div>

      <div className={EditEventFormCss.formGroup}>
        <label>Event Image</label>
        {previewImageUrl && (
          <div>
            <img
              src={previewImageUrl}
              alt="Event Preview"
              className={EditEventFormCss.previewImage}
              style={{
                width: "150px",
                height: "150px",
                objectFit: "cover",
                borderRadius: "5px"
              }}
            />
            <p>Change the image by uploading a new one.</p>
          </div>
        )}
        <input
          type="file"
          accept=".jpg,.jpeg,.png"
          onChange={handleImageChange}
        />
      </div>

      <div className={EditEventFormCss.ticketInformationWrapper}>
        <h3>Edit Ticket Information</h3>
        <div className={EditEventFormCss.ticketSelector}>
          <Select
            value={selectedTicketType}
            onChange={handleTicketSelect}
            options={availableTicketTypes}
            placeholder="Select Ticket Type"
            className={EditEventFormCss.addTicketButton}
            styles={customSelectStylesTickets}
            menuPlacement="top"
            menuPortalTarget={document.body}
          />
        </div>
        <table className={EditEventFormCss.ticketTable}>
          <thead>
            <tr>
              <th className={EditEventFormCss.columnHeader}>Type</th>
              <th className={EditEventFormCss.columnHeader}>Price (€)</th>
              <th className={EditEventFormCss.columnHeader}>Quantity</th>
              <th className={EditEventFormCss.columnHeader}>Description</th>
              <th className={EditEventFormCss.columnHeader}>Image</th>
              <th className={EditEventFormCss.columnHeader}>Delete</th>
            </tr>
          </thead>
          <tbody>
            {tickets.map((ticket, index) => (
              <tr key={index} className={EditEventFormCss.ticketRow}>
                <td className={EditEventFormCss.ticketType}>
                  {ticket.ticketType}
                </td>
                <td>
                  <input
                    type="number"
                    value={ticket.price}
                    className={EditEventFormCss.ticketInput}
                    onChange={(e) =>
                      handleTicketChange(index, "price", e.target.value)
                    }
                  />
                </td>
                <td>
                  <input
                    type="number"
                    value={ticket.numberOfTicketsLeft}
                    className={EditEventFormCss.ticketInput}
                    onChange={(e) =>
                      handleTicketChange(
                        index,
                        "numberOfTicketsLeft",
                        e.target.value
                      )
                    }
                  />
                </td>
                <td>
                  <textarea
                    value={ticket.description}
                    className={EditEventFormCss.ticketTextarea}
                    onChange={(e) =>
                      handleTicketChange(index, "description", e.target.value)
                    }
                  />
                </td>
                <td>
                  {ticket.ticketImage ? (
                    <img
                      src={ticket.ticketImage}
                      alt="Selected"
                      className={EditEventFormCss.thumbnail}
                      onClick={() => handleSelectTicketImage(index)}
                    />
                  ) : (
                    <button
                      type="button"
                      onClick={() => handleSelectTicketImage(index)}
                      className={EditEventFormCss.imageButton}
                    >
                      <FontAwesomeIcon icon={faImage} />
                    </button>
                  )}
                </td>
                <td>
                  <button
                    type="button"
                    className={EditEventFormCss.deleteTicketButton}
                    onClick={() => handleDeleteTicket(index)}
                  >
                    <img src={TrashcanIcon} alt="Delete Ticket" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className={EditEventFormCss.submitButtonRow}>
        <button
          type="submit"
          className={EditEventFormCss.submitButton}
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <>
              <img
                src={SpinnerIcon}
                alt="Loading"
                className={EditEventFormCss.spinner}
              />
              Your changes are being made...
            </>
          ) : (
            "Save Changes"
          )}
        </button>
      </div>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        contentLabel="Select Ticket Image"
        style={{
          content: {
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#F0F0F0",
            borderRadius: "5px",
            width: "60%",
            height: "auto",
          },
          overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
        }}
      >
        <h2>Select Ticket Image</h2>
        {!selectedFolder ? (
          <div className={EditEventFormCss.folderSelection}>
            {Object.keys(TICKET_IMAGES).map((folderName) => (
              <button
                key={folderName}
                onClick={() => setSelectedFolder(folderName)}
                className={EditEventFormCss.folderButton}
              >
                {folderName}
              </button>
            ))}
          </div>
        ) : (
          <div className={EditEventFormCss.imageSelection}>
            <button
              className={EditEventFormCss.backButton}
              onClick={() => setSelectedFolder(null)}
            >
              Atras
            </button>
            {TICKET_IMAGES[selectedFolder].map((imageUrl, index) => (
              <img
                key={index}
                src={imageUrl}
                alt={`Ticket option ${index}`}
                onClick={() => handleImageSelection(imageUrl)}
                className={`${EditEventFormCss.selectableImage} ${tickets[currentTicketIndex]?.ticketImage === imageUrl
                  ? EditEventFormCss.selectedImage
                  : ""
                  }`}
              />
            ))}

          </div>
        )}
        <button
          className={EditEventFormCss.closeButton}
          onClick={() => setIsModalOpen(false)}
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </Modal>

    </form>
  );
};

export default EditEventForm;
